import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";

import { UserInfo_initialize, UserSet, UpdateUser } from "../../stores/slices/UserInfo";
import { getLocalStorage, UserInfoGet } from "../../stores/Information";

const UserInfo = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const informationState = useSelector((state) => state.Information);
    const UserInfoState = useSelector((state) => state.UserInfo);

    useEffect(() => {
        //ログインしていないならログイン画面へ
        if(!getLocalStorage("organizer"))
        {
            history.push(`/Login`);
            return;
        }

        dispatch(UserInfo_initialize([informationState["organizer"]]));
    }, [informationState]);

    //変更ボタン
    const HandleSubmit = (e) => {
        e.preventDefault();

        if(confirm('入力内容で登録内容を変更します。よろしいですか？'))
        {
            //更新処理
            dispatch(UpdateUser(UserInfoState)).then((user_data) => {
                const result = user_data.payload.result;
                console.log(result);
                if(result === 'OK')
                {
                    dispatch(UserInfoGet(null));
                    alert('変更が完了しました。');
                }
                else
                {
                    //NGメッセージ表示
                    alert(user_data.payload.message);
                }
            });
        }
    };

    //パスワード変更
    const PasswordSettingClick = () => {
        history.push(`/PasswordSettingEdit`);
    };

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(UserSet([name, value]));
    };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                会員情報
            </Typography>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center" sx={{ mb: 3 }}>
                <Button
                    variant="contained"
                    fullWidth sx={{ maxWidth: "10rem" }}
                    onClick={PasswordSettingClick}
                    //style={{ display: UserInfoState.yahoo_token ? 'none' : '' }}
                >
                    パスワード変更
                </Button>
            </Grid>
            <form onSubmit={HandleSubmit}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: "300px" }}
                >
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        メールアドレス
                    </Typography>
                    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                        <TextField
                            required
                            sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                            label="メールアドレス"
                            variant="outlined"
                            name="email_address"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 60 }}
                            value={UserInfoState.email_address}
                            onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                            type="email"
                            disabled
                        />
                    </Grid>
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        業務上氏名
                    </Typography>
                    <TextField
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="業務上氏名"
                        variant="outlined"
                        name="business_name"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 16 }}
                        value={UserInfoState.business_name}
                        onChange={(e) => onChange({ name: "business_name", value: e.target.value })}
                    />

                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        業務上アカウント
                    </Typography>
                    <TextField
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="業務上アカウント"
                        variant="outlined"
                        name="business_account"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 60 }}
                        value={UserInfoState.business_account}
                        onChange={(e) => onChange({ name: "business_account", value: e.target.value })}
                    />
                </Grid>
                <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                    <Button variant="contained" type="submit" fullWidth sx={{ maxWidth: "10rem" }}>
                        変更
                    </Button>
                </Grid>
            </form>
        </React.Fragment>
    );
};

export default UserInfo;
